import {useTheme} from "@mui/material/styles";
import SvgIcon from "@mui/material/SvgIcon";

function OkwindIcon() {
  const theme = useTheme();
  return (
    <SvgIcon>
      <svg
        style={{
          width: "100%",
          height: "54px",
          fill: theme.palette.mode === "dark" ? "white" : "black",
        }}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 129 36"
        enableBackground="new 0 0 129 36">
        <g>
          <path
            d="M69.29,0.71v20.3c0,0.27,0.22,0.49,0.49,0.49h3.77c0.27,0,0.49-0.22,0.49-0.49V0.71
          c0-0.27-0.22-0.49-0.49-0.49h-3.77C69.51,0.22,69.29,0.44,69.29,0.71z"></path>
          <path
            d="M95.41,4.7c-0.98-2.44-3.2-4.23-5.89-4.61c-0.05-0.01-0.09-0.02-0.15-0.02c-0.3-0.03-0.6-0.06-0.91-0.06
          h-4.07c-0.31,0-0.61,0.02-0.91,0.06c-3.71,0.45-6.59,3.62-6.59,7.46v13.49c0,0.27,0.22,0.49,0.49,0.49h3.99
          c0.27,0,0.49-0.22,0.49-0.49V7.49c0-1.39,1.13-2.52,2.52-2.52h4.11c1.38,0,2.51,1.12,2.51,2.51v13.53c0,0.27,0.22,0.49,0.49,0.49
          h3.99c0.27,0,0.49-0.22,0.49-0.49V7.52C95.97,6.53,95.77,5.57,95.41,4.7z"></path>
          <path
            d="M17.71,0.22H11.3C5.03,0.22,0,4.14,0,10.83C0,17.52,4.88,21.5,11.36,21.5h6.35c2.56,0,4.63-2.07,4.63-4.63
          V4.85C22.34,2.29,20.27,0.22,17.71,0.22z M17.12,16.49c0,0.21-0.17,0.39-0.39,0.39h-5.1c-3.68,0-6.23-2.16-6.23-6.03
          c0-3.87,2.41-6.03,6.23-6.03h5.1c0.22,0,0.39,0.17,0.39,0.39v11.26V16.49z"></path>
          <path
            d="M98.97,4.85v12.03c0,2.56,2.07,4.63,4.63,4.63h6.35c6.48,0,11.36-4.18,11.36-10.67
          c0-6.49-5.04-10.62-11.31-10.62h-6.41c-2.56,0-4.63,2.07-4.63,4.63H98.97z M104.19,5.23c0-0.22,0.17-0.39,0.39-0.39h5.1
          c3.83,0,6.23,2.24,6.23,6.03c0,3.86-2.56,6.03-6.23,6.03h-5.1c-0.22,0-0.39-0.19-0.39-0.39V5.23z"></path>
          <path
            d="M66.28,0.71v13.27c0,4.15-3.37,7.52-7.52,7.52h-1.45c-2.02,0-3.87-0.81-5.23-2.12
          c-1.35,1.31-3.19,2.12-5.23,2.12h-1.46c-4.15,0-7.51-3.36-7.51-7.51V0.71c0-0.27,0.22-0.49,0.49-0.49h3.64
          c0.27,0,0.49,0.22,0.49,0.49v13.27c0,1.6,1.29,2.89,2.89,2.89h1.45c1.59,0,2.88-1.29,2.88-2.88V0.71c0-0.27,0.22-0.49,0.49-0.49
          h3.7c0.27,0,0.49,0.22,0.49,0.49v13.27c0,1.6,1.29,2.89,2.89,2.89h1.45c1.6,0,2.89-1.29,2.89-2.89V0.71c0-0.27,0.22-0.49,0.49-0.49
          h3.64c0.27,0,0.49,0.22,0.49,0.49H66.28z"></path>
          <path
            d="M30.58,0.22c-0.3,0-0.58,0.15-0.75,0.39l-5.69,8.13c-0.88,1.25-0.88,2.91-0.02,4.16l5.64,8.19
          c0.17,0.25,0.46,0.4,0.76,0.4l5.14-0.05c0.26,0,0.42-0.3,0.27-0.52l-6.67-9.48c-0.34-0.47-0.34-1.11,0.01-1.58l6.63-9.12
          c0.16-0.22,0-0.52-0.27-0.52H30.58z"></path>
          <path
            fill="#2FB109"
            d="M125.77,22.08c1.541,0,2.79-1.249,2.79-2.79c0-1.541-1.249-2.79-2.79-2.79s-2.79,1.249-2.79,2.79
          C122.98,20.831,124.229,22.08,125.77,22.08z"></path>
        </g>
      </svg>
    </SvgIcon>
  );
}

export default OkwindIcon;
